export const SHORT_TOAST_LIFE = 1500
export const DEFAULT_TOAST_LIFE = 3000
export const LONG_TOAST_LIFE = 5000
